import { render, staticRenderFns } from "./PublicHomeView.vue?vue&type=template&id=213b7245"
import script from "./PublicHomeView.vue?vue&type=script&lang=js"
export * from "./PublicHomeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports